export const PORTAL_VIEWS = [
  { key: "home", label: "Home", anchor: "account-overview", description: "Your account at a glance" },
  { key: "billing", label: "Pay & billing", anchor: "account-payments", description: "Secure payments and autopay" },
  { key: "services", label: "Services", anchor: "account-requests", description: "Your lines and service requests" },
  { key: "devices", label: "Devices & repairs", anchor: "account-device-hub", description: "Financing, quotes and repair updates" },
  { key: "rewards", label: "Rewards", anchor: "account-rewards", description: "Your points, perks and birthday gift" },
  { key: "activity", label: "Activity", anchor: "account-activity", description: "Payments, receipts and shipments" },
  { key: "profile", label: "Profile", anchor: "account-profile", description: "Your details and sign-in options" },
  { key: "help", label: "Help", anchor: "portal-support", description: "Support and portal preferences" },
];

const anchors = {
  "account-overview": "home",
  "account-payments": "billing", "portal-secure-checkout": "billing", "account-other-payments": "billing", "account-payment-reports": "billing", "account-addons": "billing", "account-autopay": "billing",
  "account-requests": "services", "account-services": "services", "account-esims": "services", "portal-request-form": "services",
  "account-device-hub": "devices", "account-device-quotes": "devices", "account-financing": "devices", "account-repairs": "devices",
  "account-rewards": "rewards", "account-activity": "activity", "account-receipts": "activity", "account-shipments": "activity",
  "account-profile": "profile", "account-email-access": "profile",
  "portal-support": "help", "portal-settings": "help", "portal-privacy": "help",
};
export function portalViewForAnchor(hash) {
  return anchors[String(hash || "").replace(/^#/, "")] || null;
}
export function initialPortalView(search, hash) {
  const params = new URLSearchParams(search);
  return params.has("checkout") || params.has("autopay") ? "billing" : portalViewForAnchor(hash) || "home";
}

export function portalDomainRedirect(hostname, { pathname, search = "", hash = "" }) {
  return hostname === "alkeya.app" && pathname === "/" ? `/portal${search}${hash}` : null;
}

export function portalShareOrigin({ hostname, origin }) {
  return ["alkeya.app", "alkeya-mobile.web.app", "alkeya-mobile.firebaseapp.com", "alkeyamobile.com"].includes(hostname)
    ? "https://alkeya.app" : origin;
}
